import type { DeprecatedColorKeys } from "@/styles/deprecated-colors";

import type { FaqProps as GenericFaqsProps } from "../../Faq/Faq";
import type { EventProps } from "../types";

export const bodyVariants = {
  Text1: "Text1",
  Text2: "Text2",
  Text3: "Text3",
  Text4: "Text4",
  Text5: "Text5",
  Text6: "Text6",
  Label: "Label",
} as const;

export type BodyVariant = keyof typeof bodyVariants;

interface FaqItemProps {
  answer: string;
  question: string;
}

export interface FaqsProps {
  bodyVariant: BodyVariant;
  borderColor: DeprecatedColorKeys;
  event: EventProps;
  iconColor: DeprecatedColorKeys;
  items: FaqItemProps[];
  questionTextVariant: BodyVariant;
  textColor: DeprecatedColorKeys;
}

export interface FaqProps extends GenericFaqsProps {
  answer: string;
  bodyVariant?: BodyVariant;
  isOpen: boolean;
  questionTextVariant?: BodyVariant;
  textColor?: DeprecatedColorKeys;
}

export interface RichTextContainerProps {
  bodyVariant: BodyVariant;
  dangerouslySetInnerHTML: {
    __html: string;
  };
  textColor?: DeprecatedColorKeys;
}
